import React from 'react'
import FlashBannerMessage from '@components/FlashBanner/shared/FlashBannerMessage'
import FlashBannerDiscount from '@components/FlashBanner/shared/FlashBannerDiscount'
import FlashBannerLink from '@components/FlashBanner/shared/FlashBannerLink'
import FlashBannerItemWrapper from '@components/FlashBanner/shared/FlashBannerItemWrapper'
import FlashBannerMessageWrapper from '@components/FlashBanner/shared/FlashBannerMessageWrapper'
import FlashBannerButton from '../shared/FlashBannerButton'
import { FlashBannerItem } from 'types/contentful/graphQlApi'
import { EmptyObject } from 'types/helpers'
import { useMediaQuery } from '@helpers/hooks'
import { BREAKPOINT_SIZES } from '@consts/index'

export type PromoBannerProps = Omit<
  FlashBannerItem,
  '__typename' | 'bannerName' | 'showBanner'
> & {
  onClick?: () => void
  showIconMobile?: boolean
}

const PromoBanner = ({
  messageDesktop,
  messageMobile,
  contentColor = 'white',
  discount,
  discountLabel,
  linkTextDesktop,
  linkUrl,
  backgroundColor,
  onClick
}: PromoBannerProps | EmptyObject) => {
  const isPhabletDown = useMediaQuery({
    maxWidth: BREAKPOINT_SIZES.TABLET - 1
  })
  const messageMobileTrimmed = messageMobile?.trim() || ''
  const messageDesktopTrimmed = messageDesktop?.trim() || ''
  const isLargeMobileText =
    isPhabletDown && messageMobileTrimmed.length >= 39 && discount

  return (
    <FlashBannerItemWrapper
      data-testid="PromoBanner"
      link={linkUrl}
      backgroundColor={backgroundColor}
      onClick={onClick}
      size={`${isLargeMobileText ? 'large' : 'regular'}`}
    >
      <FlashBannerMessageWrapper center={!linkUrl}>
        <FlashBannerMessage
          contentColor={contentColor}
          messageDesktop={messageDesktopTrimmed}
          messageMobile={messageMobileTrimmed}
        />
        {!!discount && !!discountLabel && (
          <FlashBannerDiscount
            contentColor={contentColor}
            discountLabel={discountLabel}
            discount={discount}
            center={!!linkUrl}
          />
        )}
      </FlashBannerMessageWrapper>
      {!!linkUrl && !!linkTextDesktop && (
        <FlashBannerLink
          contentColor={contentColor}
          linkUrl={linkUrl}
          linkTextDesktop={linkTextDesktop}
        />
      )}
      {!linkUrl && typeof onClick === 'function' && !!linkTextDesktop && (
        <FlashBannerButton
          contentColor={contentColor}
          linkTextDesktop={linkTextDesktop}
        />
      )}
    </FlashBannerItemWrapper>
  )
}

export default PromoBanner
